import { useTu } from "@src/appV2/i18n/useTu";
import { type ButtonSize } from "@src/appV2/redesign/components/Button";
import { type IconType } from "@src/appV2/redesign/components/Icon.types";

import { ContactPopoverButton } from "./ContactPopoverButton";

const HELP_ICON_TYPE: IconType = "question-circle";

interface HelpButtonProps {
  // Kept synchronous on purpose: the Help Center entry can transitively reach
  // useOpenAsyncUrl, which must be called inside the original click gesture
  // (Safari popup blocker). Never widen this to an async handler.
  onClickHelpButton: () => void;
  size?: ButtonSize;
}

export function HelpButton(props: HelpButtonProps) {
  const { onClickHelpButton, size } = props;
  const { tu } = useTu("navigation");

  return (
    <ContactPopoverButton
      triggerLabel={tu("Help")}
      triggerEndIconType={HELP_ICON_TYPE}
      triggerSize={size}
      dialogTitle={tu("Help")}
      showHelpCenterSection
      onHelpCenterClick={onClickHelpButton}
    />
  );
}
